import React from 'react';
import { useHistory } from 'react-router-dom'; 
import { Box, Button, Typography } from '@mui/material';

function Page1SubPageC() {
  const history = useHistory(); 

  return (
    <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/c/subPage1Ca')}
                    >
                        Popular Academia
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/c/subPage1Cb')}
                    >
                        University
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/c/subPage1Cc')}
                    >
                        Academic Subjects
                    </Button>
             </Box>
          </div>
    /*
    <Box p={4}>
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button variant="contained" onClick={() => history.push('/page1/c/subPage1Ca')}>
          Popular Academia
        </Button>
        <Button variant="contained" onClick={() => history.push('/page1/c/subPage1Cb')}>
          University
        </Button>
        <Button variant="contained" onClick={() => history.push('/page1/c/subPage1Cc')}>
          Academic Subjects
        </Button>
      </Box>
    </Box>
    */
  );
}

export default Page1SubPageC;

/*
import React from 'react';
import { Box, Typography } from '@mui/material';

function Page1SubPageC() {
  return (
    <Box p={4}>
      <Typography variant="h4">Academia</Typography>
    </Box>
  );
}

export default Page1SubPageC;
*/